import { supabase } from "../../supabase/supabase";
import {
  checkLanguageConfiguration,
  type LanguageConfiguration,
} from "@/config/language-rules";

/**
 * Reads the SAVED language setting of one assistant. Answers null when there is no setting, the
 * stored value is not valid, or the read fails (for example a database that does not have the
 * column yet). It never throws: a call must still be startable.
 */
export async function getAssistantLanguageSetting(
  assistantId: string | null | undefined,
): Promise<LanguageConfiguration | null> {
  if (!assistantId) return null;
  try {
    // The generated types do not know this column yet, so the column list is cast.
    const { data, error } = await supabase
      .from("assistants")
      .select("language_configuration" as any)
      .eq("id", assistantId)
      .maybeSingle();
    if (error || !data) return null;
    return checkLanguageConfiguration((data as any).language_configuration);
  } catch {
    return null;
  }
}
